import { useMutation, useQueryClient } from '@tanstack/react-query'
import { policyCatalogKeys, policyOrderKeys } from '@/modules/hierarchy'
import { printerPolicyDefinitionKeys } from '../printer-policies/printer-policy-definition-query'
import {
  eventRulePoliciesApi,
  type EventRulePolicyEdit,
  type PrinterEventRulePolicy,
} from '../../api/event-rule-policies-api'

export function useSaveEventRulePolicy(entityId: string) {
  const client = useQueryClient()
  return useMutation({
    mutationFn: ({
      policy,
      operationId,
      ruleId,
      edit,
    }: {
      policy: PrinterEventRulePolicy | null
      operationId: string
      ruleId: string
      edit: EventRulePolicyEdit
    }) =>
      policy
        ? eventRulePoliciesApi.update(entityId, policy, edit)
        : eventRulePoliciesApi.create(entityId, operationId, ruleId, edit),
    retry: false,
    onSuccess: () => Promise.all([
      client.invalidateQueries({ queryKey: policyCatalogKeys.all(entityId) }),
      client.invalidateQueries({ queryKey: policyOrderKeys.all(entityId) }),
      client.invalidateQueries({ queryKey: printerPolicyDefinitionKeys.all(entityId) }),
    ]),
  })
}

export function useDeleteEventRulePolicy(entityId: string) {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (policy: PrinterEventRulePolicy) =>
      eventRulePoliciesApi.delete(entityId, policy),
    retry: false,
    onSuccess: () => Promise.all([
      client.invalidateQueries({ queryKey: policyCatalogKeys.all(entityId) }),
      client.invalidateQueries({ queryKey: policyOrderKeys.all(entityId) }),
      client.invalidateQueries({ queryKey: printerPolicyDefinitionKeys.all(entityId) }),
    ]),
  })
}
